<template>
  <el-carousel
    :arrow="viewList.length > 1 ? arrow : 'never' " 
    :indicator-position="viewList.length > 1 ? 'outside': 'none'"
  >
    <el-carousel-item v-for="(item, index) in viewList" :key="index">
      <slot name="content" :item="item" />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  props: {
    viewList: {
      type: Array,
      required: true
    },
    // 是否显示左右箭头： 可选值——hover/never/always
    arrow: {
      type: String,
      default: 'hover'
    },
  }

}
</script>

<style lang="less" scoped>

</style>
